<template>
  <table style="width: 100%; height: 50px; border: 1px solid rgba(255, 255, 255, 0.2)">
    <tr v-for="indexr in paramsDisp.row" :key="`idr_${indexr}`">
      <td
        align="center"
        style="border: 0.5px solid rgba(255, 255, 255, 0.1)"
        v-for="indexc in paramsDisp.col"
        :key="`idc_${indexc}`"
      >
        {{ paramsDisp.data[(indexr - 1) * paramsDisp.col + indexc - 1].label }}:&nbsp;
        {{ paramsDisp.data[(indexr - 1) * paramsDisp.col + indexc - 1].value }}
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    params: {
      type: Array,
      default: () => [
        { label: "Spherical Rmin", value: "--" },
        { label: "Spherical 3 Rmin", value: "--" },
        { label: "Spherical 6 Rmin", value: "--" },
        { label: "Spherical ecc 8 Rmin", value: "--" }
      ]
    }
  },
  computed: {
    paramsDisp() {
      return {
        row: Math.ceil(this.params.length / 2.0),
        col: 2,
        data: this.params
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/topography/components/FourierParams.vue